import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
// todo: consult FE what the keyhandler this should have
import React, { useState, useLayoutEffect, Fragment } from 'react';
import { MoveUpFadeIn } from '@nerdwallet/react-animations';
import Close from '@nerdwallet/react-icon/material/Close';
import { ImpressionContext } from '@nerdwallet/analytics/react/impression';
import analyticsLib from '@nerdwallet/analytics';
import { ElementInteraction } from '@nerdwallet/nw-client-lib/tracking';
import classNames from 'classnames';
import { ComparisonGrid } from '../comparison-grid/comparison-grid';
import { ComparisonGridSkittle } from '../comparison-grid-skittle/comparison-grid-skittle';
import StickyBanner from './sticky-banner';
import styles from '../comparison-grid.module.less';
import { EVENT_TYPES, ENTITY_NAME, ACTION, INTERACTION_TYPE } from '../../lib/analytics-constants';

var ComparisonGridPanel = function ComparisonGridPanel(_ref) {
  var _comparisonGridSkittl;

  var comparisonGridSkittleProps = _ref.comparisonGridSkittleProps,
      comparisonGridProps = _ref.comparisonGridProps,
      renderStickyBanner = _ref.renderStickyBanner,
      productType = _ref.productType,
      classes = _ref.classes;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      showComparisonGridPanel = _useState2[0],
      updateShowComparisonGridPanel = _useState2[1];

  var _useState3 = useState((_comparisonGridSkittl = comparisonGridSkittleProps === null || comparisonGridSkittleProps === void 0 ? void 0 : comparisonGridSkittleProps.showSkittlePopover) !== null && _comparisonGridSkittl !== void 0 ? _comparisonGridSkittl : true),
      _useState4 = _slicedToArray(_useState3, 2),
      showSkittlePopover = _useState4[0],
      updateShowSkittlePopover = _useState4[1]; // eslint-disable-next-line consistent-return


  useLayoutEffect(function () {
    if (showComparisonGridPanel) {
      // Get original value of body overflow
      var originalOverFlowStyle = window.getComputedStyle(document.body).overflow;
      var originalPositionStyle = window.getComputedStyle(document.body).position; // Prevent scrolling on mount

      document.body.style.overflow = 'hidden';
      document.body.style.position = 'fixed'; // Re-enable scrolling when component unmounts

      return function () {
        document.body.style.overflow = originalOverFlowStyle;
        document.body.style.position = originalPositionStyle;
      };
    }
  }, [showComparisonGridPanel]);

  var hideComparisonGridPanel = function hideComparisonGridPanel() {
    updateShowComparisonGridPanel(false);
    updateShowSkittlePopover(false);
  };

  var onComparisonGridClose = function onComparisonGridClose(impressionId) {
    analyticsLib.track(EVENT_TYPES.ELEMENT_INTERACTED, {
      action: ACTION.CLOSE,
      entity_name: ENTITY_NAME.COMPARISON_GRID_CLOSE,
      interaction_type: INTERACTION_TYPE.PRESS,
      impression_id: impressionId
    });
    hideComparisonGridPanel();
  };

  var renderLaunchComponent = function renderLaunchComponent() {
    var _comparisonGridProps$, _comparisonGridProps$2, _comparisonGridProps$3, _comparisonGridProps$4;

    return renderStickyBanner ? /*#__PURE__*/React.createElement(StickyBanner, {
      numEntitiesToCompare: comparisonGridSkittleProps.numEntitiesToCompare,
      entitiesToCompare: (_comparisonGridProps$ = comparisonGridProps === null || comparisonGridProps === void 0 ? void 0 : (_comparisonGridProps$2 = comparisonGridProps.gridTabs) === null || _comparisonGridProps$2 === void 0 ? void 0 : (_comparisonGridProps$3 = _comparisonGridProps$2.tabs) === null || _comparisonGridProps$3 === void 0 ? void 0 : (_comparisonGridProps$4 = _comparisonGridProps$3[0]) === null || _comparisonGridProps$4 === void 0 ? void 0 : _comparisonGridProps$4.entitiesToCompare) !== null && _comparisonGridProps$ !== void 0 ? _comparisonGridProps$ : [],
      removeEntityClickHandler: comparisonGridProps.removeEntityClickHandler,
      onCompareButtonClick: function onCompareButtonClick() {
        return updateShowComparisonGridPanel(true);
      }
    }) : /*#__PURE__*/React.createElement(ComparisonGridSkittle, _extends({}, comparisonGridSkittleProps, {
      onCompareSkittleClick: function onCompareSkittleClick() {
        return updateShowComparisonGridPanel(true);
      },
      showSkittlePopover: showSkittlePopover,
      updateShowSkittlePopover: updateShowSkittlePopover,
      productType: productType
    }));
  };

  return /*#__PURE__*/React.createElement(ImpressionContext.Consumer, null, function (impressionContext) {
    return /*#__PURE__*/React.createElement(Fragment, null, showComparisonGridPanel ? /*#__PURE__*/React.createElement("div", {
      className: styles.comparisonGridPanelBackgroundOverlay
    }) : renderLaunchComponent(), /*#__PURE__*/React.createElement("div", {
      className: styles.comparisonGridStickyPanel
    }, /*#__PURE__*/React.createElement(MoveUpFadeIn, {
      show: showComparisonGridPanel
    }, /*#__PURE__*/React.createElement("div", {
      className: classNames(styles.comparisonGridPanel, classes === null || classes === void 0 ? void 0 : classes.panel)
    }, /*#__PURE__*/React.createElement(ElementInteraction, {
      elementCategory: "close",
      elementName: ENTITY_NAME.COMPARISON_GRID_CLOSE,
      id: ENTITY_NAME.COMPARISON_GRID_CLOSE,
      type: "CLICK"
    }, /*#__PURE__*/React.createElement("span", {
      className: classes === null || classes === void 0 ? void 0 : classes.close,
      onClick: function onClick() {
        return onComparisonGridClose(impressionContext === null || impressionContext === void 0 ? void 0 : impressionContext.impressionId);
      }
    }, /*#__PURE__*/React.createElement(Close, {
      size: 24,
      className: styles.comparisonGridPanelClose
    }))), /*#__PURE__*/React.createElement(ComparisonGrid, _extends({}, comparisonGridProps, {
      productType: productType,
      hideComparisonGridPanel: hideComparisonGridPanel,
      renderStickyBanner: renderStickyBanner
    }))))));
  });
};

export default ComparisonGridPanel;